import { BreakpointObserver } from "@angular/cdk/layout";
import { MaterialContent } from "./material-content.component";
import { Meta, Title } from "@angular/platform-browser";
import { SidenavService } from 'src/app/_services/sidenav.service';
import { NavigationEnd, Router } from "@angular/router";
import { DestroyRef, inject } from "@angular/core";
import { Subscription } from "rxjs";

export abstract class MaterialPage extends MaterialContent {
  
  private materialPageRouterSubscription: Subscription;
  private destroyRef = inject(DestroyRef);
    
  constructor (
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    protected sidenavService: SidenavService,
    router: Router,
    pageTitle: string,
    pageDescription: string = "",
    materialV2: boolean = false
    ) {

    super(breakpointObserver, materialV2);

    this.materialPageRouterSubscription = router.events.subscribe(event => {
        
      if (event instanceof NavigationEnd && event.urlAfterRedirects === router.url) {
        this.injectSidenav();
        titleService.setTitle("Listx - " + pageTitle);
        meta.addTag({ name: 'description', content: pageDescription });
      }
    });
    
    this.destroyRef.onDestroy(() => {
      this.materialPageRouterSubscription.unsubscribe();  
    });
  }
  
  protected injectSidenav() {
    this.sidenavService.setPageSpecificNavigationPortal(null);
  }
}